import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=city&instance=${instance}`
    }
    
    return [{
        instance: instance,
        pageLayout: 'tabs_small',
        pageTitle: '数据服务-dataWANG',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        icons: [
            {
                name: 'dataWANG',
                img: '/icons/时间线.svg',
                background: 'black',
                url: "/browser2?file_path=/内容文件v2025-2/赋能生态/数据服务/dataWANG.pdf",
                path: "数据服务-dataWANG",
            },
        ]
    }]
}